import React, { useRef } from 'react';
import { Spacing, Text } from '@reservamos/elements';
import useStripe from 'hooks/libs/useStripe';
import 'styles/components/StripeForm';

/**
 * Renders the Stripe PaymentElement form.
 *
 * The PaymentElement handles card input, cardholder name, and 3DS authentication inline.
 * Styling is controlled via the Stripe Appearance API (configured in whitelabel env.stripe.appearance).
 * While Stripe.js finishes mounting the element, the component renders a small loading hint.
 *
 * @component
 * @returns {React.ReactElement} The rendered component.
 */
const StripeForm = () => {
  const stripeElement = useRef(null);
  const { ready } = useStripe(stripeElement);

  return (
    <Spacing vertical>
      {!ready && <Text size="S">Stripe</Text>}
      <div ref={stripeElement} className="stripe-payment-element" aria-busy={!ready} />
    </Spacing>
  );
};

StripeForm.propTypes = {};

export default StripeForm;
